import ElectiveDisciplinesForm from "./ElectiveDisciplinesForm";

export default ElectiveDisciplinesForm;